import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, ChevronRight, Sparkles } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../lib/supabaseClient';

const Messages = () => {
  const { user } = useAuth();
  const [convos, setConvos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    const load = async () => {
      // Get accepted sparks where user is involved
      const { data } = await supabase.from('sparks')
        .select(`id, business:businesses(name, cover_image_url), investor_id, entrepreneur_id, investor:profiles!sparks_investor_id_fkey(id, full_name, avatar_url), entrepreneur:profiles!sparks_entrepreneur_id_fkey(id, full_name, avatar_url)`)
        .eq('status', 'accepted')
        .or(`investor_id.eq.${user.id},entrepreneur_id.eq.${user.id}`)
        .order('responded_at', { ascending: false });
      setConvos(data || []);
      setLoading(false);
    };
    load();
    const ch = supabase.channel(`msgs-list-${user.id}`)
      .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'messages' }, load)
      .subscribe();
    return () => { supabase.removeChannel(ch); };
  }, [user]);

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-6">
      <div className="mb-5">
        <h1 className="heading-display text-2xl font-bold">Conversas</h1>
        <p className="text-xs text-slate-400 mt-0.5">Chats liberados pelas Sparks aceitas</p>
      </div>

      {loading && <div className="py-10 text-center text-sm text-slate-400">Carregando...</div>}

      {!loading && convos.length === 0 && (
        <div className="glass-card rounded-3xl p-10 text-center">
          <Sparkles size={32} className="mx-auto text-[#ffd54f] mb-3" />
          <div className="text-sm font-bold">Nenhuma conversa ainda</div>
          <p className="text-xs text-slate-400 mt-2">Quando uma Spark for aceita, o chat aparece aqui.</p>
        </div>
      )}

      <div className="space-y-2">
        {convos.map((c) => {
          const other = c.investor_id === user.id ? c.entrepreneur : c.investor;
          return (
            <Link key={c.id} to={`/app/chat/${c.id}`} className="glass-card rounded-2xl p-3 flex items-center gap-3 hover:bg-white/[0.06]">
              <div className="w-12 h-12 rounded-xl overflow-hidden bg-gradient-to-br from-[#4facfe] to-[#ffa726] flex items-center justify-center font-bold text-sm">
                {other?.avatar_url ? <img src={other.avatar_url} alt="" className="w-full h-full object-cover"/> : (other?.full_name||'U').charAt(0).toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold truncate">{other?.full_name}</div>
                <div className="text-[11px] text-slate-400 truncate flex items-center gap-1">
                  <Sparkles size={10} className="text-[#ffd54f]"/> {c.business?.name}
                </div>
              </div>
              <ChevronRight size={16} className="text-slate-500" />
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default Messages;
